import React from "react";
import { Col, Row } from "react-bootstrap";
var BankAccount = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12 },
                React.createElement("div", { className: "bankaccountsection ".concat(props.parentClass) },
                    React.createElement("div", { className: "accountNumber" },
                        React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray " }, props.sectionHeadleftTop),
                        React.createElement("span", { className: "DMSanM_14_500" }, props.sectionHeadleftBottom)),
                    React.createElement("div", { className: "bankname" },
                        React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray" }, props.sectionHeadRightTop),
                        React.createElement("span", { className: "DMSanM_14_500" },
                            props.hideIcon ? null : (React.createElement("i", { className: "edel-icon-flash pe-1 txt-orange-light" })),
                            props.sectionHeadRightBottom)),
                    props.sectionHeadleft2Top && (React.createElement("div", { className: "accountNumber pt-3" },
                        React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray " }, props.sectionHeadleft2Top),
                        React.createElement("span", { className: "DMSanM_14_500" }, props.sectionHeadleft2Bottom))))))));
};
export default BankAccount;
